import { render } from "./GenericModal.vue?vue&type=template&id=63ff60a1&scoped=true&ts=true"
import script from "./GenericModal.vue?vue&type=script&lang=ts"
export * from "./GenericModal.vue?vue&type=script&lang=ts"

import "./GenericModal.vue?vue&type=style&index=0&id=63ff60a1&lang=scss&scoped=true"

import exportComponent from "/home/satou/deinjobfuchs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ff60a1"]])

export default __exports__